import type { DocumentItem, PrepareUploadFiles, OCRFileDataItem } from '@/api/product/model/documentModel'
import { SortTypeEnum } from '@/enums/sortTypeEnum'
import { SortInfo } from '@/views/product/DocumentDetail/types/sort'

export interface State {
  modalFileAdditionActived: boolean
  modalProductRelationActived: boolean
  //画面表示用データ
  originalDocumentItem: DocumentItem
  //画面初期化時に取ったデータ、変更内容をクリアする時に画面初期データにリセット用
  compareDocumentItem: DocumentItem
  selectedFile: File | undefined
  newFileRevisionDate: string
  prepareUploadFiles: PrepareUploadFiles

  selectedFileError: string
  selectFileUnderError: string
  newFileRevisionDateError: string
  remarkError: string

  formUpdated: boolean
  //ドキュメント詳細画面　ファイル一覧ソート情報
  sortInfo: SortInfo

  uploadFileType: string
  //画面表示用データ
  originalOcrDataItem: OCRFileDataItem
  //画面初期化時に取ったデータ、変更内容をクリアする時に画面初期データにリセット用
  compareOcrDataItem: OCRFileDataItem
  ocrUpdateMessage: string
}

const state = (): State => ({
  modalFileAdditionActived: false,
  modalProductRelationActived: false,
  originalDocumentItem: {} as DocumentItem,
  compareDocumentItem: {} as DocumentItem,
  selectedFile: undefined,
  newFileRevisionDate: '',
  prepareUploadFiles: [],

  selectedFileError: '',
  selectFileUnderError: '',
  newFileRevisionDateError: '',
  remarkError: '',

  formUpdated: false,
  //ドキュメント詳細画面　ファイル一覧ソート情報
  sortInfo: {
    order: SortTypeEnum.ASC,
    sortColumn: '',
  },
  uploadFileType: '',
  originalOcrDataItem: {} as OCRFileDataItem,
  compareOcrDataItem: {} as OCRFileDataItem,
  ocrUpdateMessage: '',
})

export default state
